<template>
  <div class="skeleton">
    <div
      class="skeleton__img"
      v-if="hasContentImg"
      :style="computedImgStyles"
    ></div>

    <div class="skeleton__text--container">
      <span
        class="skeleton__text"
        v-for="line in lines"
        :key="line"
        :class="`${line}`"
        :style="isFullWidth"
      ></span>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  lines: {
    type: [Number, String],
    default: 3,
  },
  hasContentImg: {
    type: [Boolean, String],
    default: true,
  },
  imgSize: {
    type: [Number, String],
    default: "25px",
  },
  contentIsFullWidth: {
    type: [Boolean, String],
    default: false,
  },
});

const isFullWidth = computed(() =>
  props.contentIsFullWidth ? { width: "300px" } : ""
);

const computedImgStyles = computed(() =>
  props.imgSize ? { width: props.imgSize, height: props.imgSize } : ""
);
</script>

<style lang="scss" scoped>
$skele-bg: var(--input-background);
$on-skele-surface-bg: var(--dropdown-background);

.skeleton {
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;
  padding: 10px;

  background-color: $skele-bg;
  border-radius: $border-radius;

  &__img {
    position: relative;
    overflow: hidden;
    border-radius: 50%;
    margin-left: 10 px;
  }

  &__text {
    height: 16px;
    margin: 5px;
    width: 100%;
    min-width: 40px;

    &--container {
      display: flex;
      flex-direction: column;
    }

    &:nth-child(odd) {
      max-width: 300px;
    }

    &:nth-child(even) {
      max-width: 240px;
    }
  }

  &__text,
  &__img {
    background: $on-skele-surface-bg;
    background: linear-gradient(
      110deg,
      $on-skele-surface-bg 8%,
      $skele-bg 18%,
      $on-skele-surface-bg 33%
    );
    background-size: 200% 100%;
    background-position-x: 180%;
    animation: 1.8s loading linear infinite;
  }

  @keyframes loading {
    to {
      background-position-x: -200%;
    }
  }
}
</style>
